import * as Popover from '@radix-ui/react-popover';
import {
	DesktopCategoryOption,
	NavigationCategory,
	NavigationOptionKey,
	NavigationState,
} from 'src/components/Navigation/types';
import DesktopNavDropdownContent from 'src/components/Navigation/DesktopNav/DesktopNavDropdown/DesktopNavDropdownContent';
import DesktopNavButton from 'src/components/Navigation/DesktopNav/DesktopNavButton';
import useDesktopNavDropdown from 'src/components/Navigation/DesktopNav/DesktopNavDropdown/hooks/useDesktopNavDropdown';

interface Props {
	currentNavSelection: NavigationOptionKey | undefined;
	navCategory: NavigationCategory;
	navOption: DesktopCategoryOption;
	handleNavigation: NavigationState['handleNavigation'];
	isActive: boolean;
}

export default function DesktopNavDropdown({
	currentNavSelection,
	navCategory,
	navOption,
	handleNavigation,
	isActive,
}: Props) {
	const {
		open,
		setOpen,
		handleMouseEnter,
		handleMouseLeave,
		handleCloseAutofocus,
	} = useDesktopNavDropdown();

	return (
		<Popover.Root open={open} onOpenChange={setOpen}>
			<Popover.Trigger
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				asChild
			>
				<DesktopNavButton
					className={navOption.className}
					navCategory={navCategory}
					navOption={navOption}
					isActive={isActive}
					handleNavigation={handleNavigation}
					isOpen={open}
				/>
			</Popover.Trigger>
			<Popover.Portal>
				<Popover.Content
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
					onCloseAutoFocus={handleCloseAutofocus}
					sideOffset={8}
					asChild
				>
					<DesktopNavDropdownContent
						navOption={navOption}
						onClick={handleNavigation}
						currentNavSelection={currentNavSelection}
					/>
				</Popover.Content>
			</Popover.Portal>
		</Popover.Root>
	);
}
